import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
import { GraphQLAPI } from '@aws-amplify/api-graphql'; // ✅ modular API plugin
import config from './aws-exports';
import { BrowserRouter } from 'react-router-dom'; // ✅ Import BrowserRouter

// ✅ Read API key from env (set in .env.local as REACT_APP_PCC_API_KEY=...)
const PCC_API_KEY = process.env.REACT_APP_PCC_API_KEY;

// ✅ Build a config that reuses aws-exports but adds x-api-key for pccapi
const amplifiedConfig = {
  ...config,
  API: {
    endpoints: config.aws_cloud_logic_custom.map((ep) => {
      if (ep.name === 'pccapi') {
        // Attach x-api-key header ONLY for the pccapi endpoint
        return {
          ...ep,
          custom_header: async () => ({
            'x-api-key': PCC_API_KEY,
          }),
        };
      }
      // Leave other REST APIs (like accountRequestsAPI) unchanged
      return ep;
    }),
  },
};

// ✅ Configure Amplify with the extended config
Amplify.configure(amplifiedConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
